import { DisabledPrompt, Link, useModel } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";

/**
 * @function AccountSummaryBrandableLinksWidget
 * @return {React.Component}
 * @exported true
 * @description This is the main widget of the AccountSummaryBrandableLinksWidget
 */
export default function AccountSummaryBrandableLinksWidget(props) {
    const { branding, demos } = useModel();
    const { options } = branding;
    const mabi23Branding = Util.getMABI23Branding() || {};
    const mabi23Options = mabi23Branding.options || { options: {} };

    const openAccount = () => {
        let origVersion = branding.options.orig_version_abi22;
        if(origVersion !== "ORIG19") origVersion = "ORIG20";
        window.open(demos[origVersion], "_blank");
    };
    
    const buildLinks = (link,index)=>{
        if(link === "Edit Accounts View"){
            return <Link to="/editAccountsView/" className="edit-accounts-view-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Edit_Accounts_View_Link"}>Edit Accounts View</Link>
        }
        if(link === "Search"){
            return <DisabledPrompt>
                        <Link to="" className="search-link  widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Search_Link"}>
                            <SVGAsset id="MagnifyingGlassIcon" className="search-icon" />
                            <span>Search</span>
                        </Link>
                    </DisabledPrompt> 
            
        }
        if(link === "Download"){
            return <Link to="/download" className="download-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Download_Link"}>Download</Link>
        }
        if(link === "Open an Account"){
            
            return options.orig_courseid_abi22 == null?
            <DisabledPrompt> 
                <Link to="" className="open_account-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Open_account_Link"}>Open an Account</Link>
            </DisabledPrompt> 
        
        :   <Link to="" className="open_account-link widget-link set-width" dataPoint={index ===1?"Account_Summary_First_Link":"Account_Summary_Open_account_Link"} onClick={ openAccount }>Open an Account</Link>     
        }

        if(link === "Download Transactions") {
            return <Link to="/downloadTransactions" className="download-transactions-link widget-link set-width" dataPoint={index === 1 ? "Account_Summary_First_Link" : "Account_Summary_Download_Transactions_Link" }>Download Transactions</Link>
        }

        if(link === "Reorder Accounts") {
            return <Link to="/reorderAccounts" className="reorder-accounts-link widget-link set-width" dataPoint={index === 1 ? "Account_Summary_First_Link" : "Account_Summary_Reorder_Accounts_Link" }>Reorder Accounts</Link>
        }

        let varLink = link.replaceAll(" ","_") ?? "link";
        return <DisabledPrompt>
                    <Link to="" className={varLink+"-link widget-link set-width"} dataPoint={index ===1?"Account_Summary_First_Link":("Account_Summary_"+varLink)}>{link}</Link>
                </DisabledPrompt> 
    }

    // START: Custom brandable links shown in the account summary widget. 
    // These links will different depending on which demo you are directly loading, mabi23 or abi22.
    let links = [1,2,3,4,5];

    links = links.map(function(link) {
        const currentABI22Option = `acctsumwidget_link_${link}_abi22`;
        const currentMABI23Option = `acctsumwidget_link_${link}_mabi23`;

        // If mabi23 link branding is set, use that branding
        // which overrides the equivalent abi22 link branding.
        if(mabi23Options[currentMABI23Option] !== "undefined" 
            && mabi23Options[currentMABI23Option] !== "None"
            && mabi23Options[currentMABI23Option] !== undefined 
        ) {
            return buildLinks(mabi23Options[currentMABI23Option], link);
        // Else if mabi23 "None" is set for this link branding, make sure we see no link.
        } else if(mabi23Options[currentMABI23Option] === "None") {
            return undefined;
        // Else, the conditions above are false and we fall back to abi22 link branding.
        } else {
            if(branding.options[currentABI22Option] !== "undefined" && branding.options[currentABI22Option] !== "None") {
                return buildLinks(branding.options[currentABI22Option], link);
            }
        }
    });
    // END: Custom brandable links shown in the account summary widget. 
    // These links will different depending on which demo you are directly loading, mabi23 or abi22.

    return (
      <>
        <div className="widget-link-container flex-container flex-horizontal">
            { links }
        </div>        
      </>    
     );              
}
